module.exports = __webpack_public_path__ + "img/en-US.50de7dfa.svg";